<script setup lang="ts">
import { useTimesheetStore } from '@/stores/timesheets';
import { getTranslations } from '@/lib/util/i18n';
import ShiftActionStatus from '@/components/ShiftActionStatus.vue';
import ShiftStartedImage from '@/assets/images/shift-confirmation.png';

const t = getTranslations({
  app: '',
  module: 'views',
  file: 'shift-action-status',
});

const timesheets = useTimesheetStore();
</script>

<template>
  <ShiftActionStatus
    :is-loading="timesheets.isProcessingShiftAction"
    :has-error="timesheets.hasAnyErrors"
    :image="ShiftStartedImage"
    :title="t('shift-started:title')"
  ></ShiftActionStatus>
</template>
